export default "__VITE_ASSET__93454014__"